import { commonFilter } from './filter';

export default {
  pageName: 'competitor',
  pageId: '20013',
  pagePath: '/opinion/Stats/Competitor',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
  },
};
